import type { OdoscopeTokenSlot } from '@goldner-group/storefront-odoscope/types'

export type ProductListingDecision = {
  source: 'odoscope' | 'scayle'
  execution: 'client' | 'server'
  tokenSlot?: OdoscopeTokenSlot
  tracking?: 'odoscope' | 'control'
  reason: string
}

export interface DecideProductListingInput {
  isCrawler: boolean
  isDefaultSort: boolean
  // ECOM-2669: the active category carries a manual sort key
  // (`shopLevelCustomData.sortingKey`). Only ever true on the default sort
  // (it is derived from `customSorting`, which is gated on `isDefaultSort`).
  hasCustomSort: boolean
  showOdoscopeExperiment: boolean
}

// Pure source-selection decision, kept free of Nuxt/SDK imports so it can be
// unit-tested directly (the composable that wraps it can't be jest-mounted —
// it depends on useNuxtApp / useExperiments). The custom-sort guard sits ahead
// of the sort branch because a curated category must be served deterministically
// by SAPI, never Odoscope's optimized order (ECOM-2669).
export const decideProductListing = ({
  isCrawler,
  isDefaultSort,
  hasCustomSort,
  showOdoscopeExperiment,
}: DecideProductListingInput): ProductListingDecision => {
  if (isCrawler) {
    return { source: 'scayle', execution: 'server', reason: 'crawler' }
  }

  if (hasCustomSort) {
    return {
      source: 'scayle',
      execution: 'client',
      tracking: 'control',
      reason: 'custom-sort',
    }
  }

  if (!isDefaultSort) {
    return {
      source: 'scayle',
      execution: 'client',
      tracking: 'control',
      reason: 'sorting',
    }
  }

  return {
    source: 'odoscope',
    execution: 'client',
    tokenSlot: showOdoscopeExperiment ? 'product' : 'controlSorting',
    tracking: 'odoscope',
    reason: 'ags-topseller',
  }
}
